import React from "react"

import FeatureStyles from "./features.module.scss"

// TODO: Find matching icons

const Features = () => (
  <section className={FeatureStyles.featuresSection}>
    <h3 className="section-subheading">Why choose us?</h3>
    <h2 className="section-heading">Features</h2>

    <div className={FeatureStyles.grid}>
      <div className={FeatureStyles.features}>
        <div className={FeatureStyles.feature}>
          <div className={FeatureStyles.websiteIcon}></div>
          <h4>Website / Mobile App</h4>
          <p>Why not let us increase your barbershops brand?</p>
          <p>
            All of our clients receive a branded website and mobile app for
            their customers.
          </p>
        </div>
        <div className={FeatureStyles.feature}>
          <div className={FeatureStyles.appointmentIcon}></div>
          <h4>Appointment System</h4>
          <p> Do your customers want to book appointments?</p>
          <p>
            All of our websites and mobile apps come with an appointment system
            built in.
          </p>
        </div>
        <div className={FeatureStyles.feature}>
          <div className={FeatureStyles.phoneIcon}></div>
          <h4>Phone Tree</h4>
          <p> Would you like assistance when your busy?</p>
          <p>
            With our phone tree your customers will be able to book appointments
            via a phone tree.
          </p>
        </div>
        <div className={FeatureStyles.feature}>
          <div className={FeatureStyles.textIcon} />
          <h4>Text System</h4>
          <p>
            Do your customers like the convience of telling you when they will
            be arriving to the shop?
          </p>
          <p>
            With our text system, they will be able to book an appointment all
            over text message.
          </p>
        </div>
      </div>

      <div className={FeatureStyles.video}></div>
    </div>
  </section>
)

export default Features
